import axios from "axios";
import { BASE_URL, PUBLIC_API_TOKEN } from "../constants/Configs";

export default class BaseService {
  private static shared: BaseService;
  public axios;
  constructor() {
    if (BaseService.shared) {
      throw new Error("Use BaseService.BaseServiceInstance instead of new.");
    }
    this.axios = axios.create({
      baseURL: `${BASE_URL}`,
      headers: {
        "Content-type": "application/json",
        "token-type": "Bearer",
      },
    });
    this.axios.interceptors.request.use(
      async (config) => {
        config.headers = {
          ...config.headers,
          api_access_token: PUBLIC_API_TOKEN(),
        };
        return config;
      },
      (error) => {
        console.log(error);
      }
    );

    BaseService.shared = this;
  }
  static getSharedInstance(): BaseService {
    return BaseService.shared ?? (BaseService.shared = new BaseService());
  }
}
